import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const useRedirectionStore = create(
  persist(
    (set, get) => ({
      landingUrl: "",
      trackingId: "",
      loginMessage: "",
      linkId: "",
      recruiterDetails: {},
      landingHash: "",
      setLandingUrl: data => {
        set({ landingUrl: data });
      },
      setTrackingId: data => {
        set({ trackingId: data });
      },
      setLoginMessage: data => {
        set({ loginMessage: data });
      },
      setLinkId: data => {
        set({ linkId: data });
      },
      setRecruiterDetails: data => {
        set({ recruiterDetails: data });
      },
      setLandingHash: data => {
        set({ landingHash: data });
      }
    }),
    {
      name: "redirection-storage", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => sessionStorage) // (optional) by default, 'localStorage' is used
    }
  )
);

export default useRedirectionStore;
